import { create } from './Create/Create.i18n.ja'
import { list } from './List/List.i18n.ja'

export const tankHistories = {
  list,
  create,
}
